import * as React from 'react';
import PropTypes from 'prop-types';

import { ButtonToolbar, OverlayTrigger, Tooltip } from 'react-bootstrap';

import logoInfoTooltip from '../../assets/img/img-tooltip.svg';

const propTypes = {
  tooltipMessage: PropTypes.string.isRequired
};

function TooltipBottom(props) {
  const tooltipFirstName = (
    <Tooltip id="tooltipFirst">
      <strong>{props.tooltipMessage} </strong>
    </Tooltip>
  );

  return (
    <ButtonToolbar>
      <OverlayTrigger id="teste" placement="bottom" overlay={tooltipFirstName}>
        <img src={logoInfoTooltip} alt="" style={{ margin: 0.0, padding: 0 }} />
      </OverlayTrigger>
    </ButtonToolbar>
  );
}

TooltipBottom.propTypes = propTypes;
export default TooltipBottom;



// WEBPACK FOOTER //
// ./src/components/tooltip/ToolTip.jsx